import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "@jti/store";
import { LoyaltyReferralCode } from "@jti/ui";
import { PromoCode } from "../../../../components/PromoCode";
import { SummaryCartItems } from "../../../../components/SummaryCartItems";
import { SummarySubscription } from "../../../../components/SummarySubscription";
import { CheckOutSteps } from "../../../../constants/checkout-constants";
import { useAemModel } from "../../../../contexts";
import { useFreeTrial } from "../../../../hooks/useFreeTrial";
import { useOrder } from "../../../../hooks/useOrder";
import { AsideLayout } from "../../../../layouts/AsideLayout";
import { categorizeItems } from "../../../../utils/categorizeItems";
import { OrderPaymentSummary } from "../OrderPaymentSummary";
import "../../../../components/CheckoutLoyaltyPoints/CheckoutLoyaltyPoints.scss";
export const PaymentPageAside = ({ submitButtonWrapperRef }) => {
    const { order, orderFetchStatus } = useOrder();
    const { isFreeTrial } = useFreeTrial();
    const { loyalty } = useAemModel();
    const { isVisible } = useSelector((store) => store.cart.promoCode);
    const products = order?.items ?? [];
    const { standardItems, subscriptionItems } = categorizeItems(products);
    const onReferralCodeApplied = () => {
        window.location.href = window.location.href.split("#")[0];
    };
    const isPromoCodeVisible = !order && isVisible && !isFreeTrial;
    return (_jsxs(_Fragment, { children: [_jsx(AsideLayout, { "data-testid": "payment-page-aside", referralCodeSlot: !isFreeTrial && loyalty.showMgm ? _jsx(LoyaltyReferralCode, { onCodeApplied: onReferralCodeApplied }) : null, slot1: isPromoCodeVisible ? _jsx(PromoCode, { step: CheckOutSteps.Payment }) : null, slot3: _jsx(SummaryCartItems, { items: standardItems, isLoading: orderFetchStatus === "pending" }), slot5: subscriptionItems?.length > 0 ? _jsx(SummarySubscription, { items: subscriptionItems }) : null, paymentSummarySlot: _jsx(OrderPaymentSummary, {}) }), _jsx("div", { "data-testid": "aside-submit-button-wrapper", ref: submitButtonWrapperRef })] }));
};
//# sourceMappingURL=PaymentPageAside.js.map